"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 30 1020 1030",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M972 546.53q-20 0-34.5 13t-16.5 33q-9 76-44 142.5t-89.5 116q-54.5 49.5-125 77.5t-149.5 28q-85 0-159.5-32.5t-130.5-88q-56-55.5-88-130t-32-159.5q0-84 32-158.5t88-130.5q56-56 130.5-88t159.5-32q23 0 44.5 2t41.5 6q13 3 25.5-.5t21.5-12.5q22-22 13.5-50.5T621 46.53q-27-5-54-8.5t-54-3.5q-106 0-199.5 40.5t-163 110q-69.5 69.5-110 163T0 546.53q0 106 40.5 199t110 163q69.5 70 163 110t199.5 40q99 0 187-35t156-96.5q68-61.5 112-144.5t55-179q2-23-13-40t-38-17zm-705-61q-15 15-15 36t15 36l151 150q18 18 43.5 18t44.5-18l433-432q15-15 15-36t-15-36q-15-15-36-15t-36 15l-361 361q-19 18-44.5 18t-43.5-18l-79-79q-15-15-36-15t-36 15z"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgCheckmark);
var _default = Memo;
exports["default"] = _default;